const CompareTable = () => {
  return (
    <>
      <table className="w-full">
        <thead>
          <tr>
            <th></th>
            <th className="text-xl font-bold text-center md:text-3xl text-blue">
              <p>Evry Health</p>
            </th>
          </tr>
        </thead>
        <tbody className="p-10">
          <tr className="border-t-2 border-white">
            <td className="py-8 text-xl font-bold text-left text-grey">
              <p>Fully-insured, employer health plan</p>
            </td>
            <td className="text-center">
              <object
                className="inline-block h-6"
                type="image/svg+xml"
                data="checkmark-blue.svg"
              ></object>
            </td>
          </tr>

          <tr className="border-t-2 border-white">
            <td className="py-8 text-xl font-bold text-left text-grey">
              <p>Built to improve medical quality</p>
            </td>
            <td className="text-center">
              <object
                className="inline-block h-6"
                type="image/svg+xml"
                data="checkmark-blue.svg"
              ></object>
            </td>
          </tr>

          <tr className="border-t-2 border-white">
            <td className="py-8 text-xl font-bold text-left text-grey">
              <p>Integrated wellness plans for every employee</p>
            </td>
            <td className="text-center">
              <object
                className="inline-block h-6"
                type="image/svg+xml"
                data="checkmark-blue.svg"
              ></object>
            </td>
          </tr>

          <tr className="border-t-2 border-white">
            <td className="py-8 text-xl font-bold text-left text-grey">
              <p>Incentive wellness card for every employee</p>
            </td>
            <td className="text-center text-blue">
              <object
                className="inline-block h-6 mt-8"
                type="image/svg+xml"
                data="checkmark-blue.svg"
              ></object>
              <p className="pt-4 md:pb-8 md:px-16">
                Everyone gets personalized wellness benefits.
              </p>
            </td>
          </tr>

          <tr className="border-t-2 border-white">
            <td className="py-8 text-xl font-bold text-left text-grey">
              <p>
                Designed to be mobile-first with an integrated iOS/Android app
              </p>
            </td>
            <td className="text-center text-blue">
              <object
                className="inline-block h-6"
                type="image/svg+xml"
                data="checkmark-blue.svg"
              ></object>
            </td>
          </tr>

          <tr className="border-white border-y-2">
            <td className="py-8 text-xl font-bold text-left text-grey">
              <p>No copays or deductibles</p>
            </td>
            <td className="text-center text-blue">
              <object
                className="inline-block h-6 mt-8"
                type="image/svg+xml"
                data="checkmark-blue.svg"
              ></object>
              <p className="my-4">
                Our premier plan has no copays or deductibles.
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </>
  )
}

export default CompareTable
